export const en = {
    'button-text': 'All ads with video extensions'
};
